
    <div *ngIf="showDisclosureName" style="padding-left: 20px; padding-right: 20px; padding-bottom: 0;">
        <div class="question-text">
            <u class="ais-disclosure-name">{{disclosureName}}</u>
            <button type="button" class="close" aria-label="Close" *ngIf="onRemove && isRemovable()"
                (click)="onRemoveClick()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
    <div class="question-body" *ngFor="let reflexiveQuestion of disclosure.questions"
        [ngSwitch]="reflexiveQuestion.answerType" [ngClass]="reflexiveQuestion.invalid ? 'invalid-question':''"  [id]="reflexiveQuestion?.code">
        <div class="question-text">
            {{reflexiveQuestion.questionText}}
        </div>
        <div class="question-form">
            <div *ngSwitchCase="ReflexiveQuestionType.BOOLEAN">
                <jhi-boolean-input [(value)]="reflexiveQuestion.answerValue" [question]="reflexiveQuestion"
                    [valueText]="reflexiveQuestion.answerText"
                    (action)="answerReflexiveQuestion(reflexiveQuestion, $event)" [summaryMode]="summaryMode">
                </jhi-boolean-input>
            </div>
            <div *ngSwitchCase="ReflexiveQuestionType.DATE">
                <div *ngIf="reflexiveQuestion.dateGranularity === 'DAY'">
                    <jhi-date-input [(value)]="reflexiveQuestion.answerValue" [enableChangeButton]="false"
                        [question]="reflexiveQuestion" [granularity]="reflexiveQuestion.dateGranularity"
                        (action)="answerReflexiveQuestion(reflexiveQuestion)" [summaryMode]="summaryMode">
                    </jhi-date-input>
                </div>
                <div *ngIf="reflexiveQuestion.dateGranularity === 'MONTH'">
                    <jhi-short-date-input [(value)]="reflexiveQuestion.answerValue" [enableChangeButton]="false"
                        [question]="reflexiveQuestion" [granularity]="reflexiveQuestion.dateGranularity"
                        (action)="answerReflexiveQuestion(reflexiveQuestion)" [summaryMode]="summaryMode">
                    </jhi-short-date-input>
                </div>
            </div>
            <div *ngSwitchCase="ReflexiveQuestionType.NUMBER">
                <jhi-numeric-input [(value)]=" reflexiveQuestion.answerValue" [enableChangeButton]="false"
                [question]="reflexiveQuestion" (action)="answerReflexiveQuestion(reflexiveQuestion)"
                [summaryMode]="summaryMode">
                </jhi-numeric-input>
            </div>
            <div *ngSwitchCase="ReflexiveQuestionType.SELECTION">
                <jhi-select-input [(value)]="reflexiveQuestion.answerValue" [options]="reflexiveQuestion.options"
                    [question]="reflexiveQuestion" [enableChangeButton]="false"
                    (action)="answerReflexiveQuestion(reflexiveQuestion)" [summaryMode]="summaryMode">
                </jhi-select-input>
            </div>
            <div *ngSwitchCase="ReflexiveQuestionType.TEXT">
                <jhi-text-input [(value)]="reflexiveQuestion.answerValue" [max]="500" [enableChangeButton]="false"
                    [question]="reflexiveQuestion" (action)="answerReflexiveQuestion(reflexiveQuestion)"
                    [summaryMode]="summaryMode">
                </jhi-text-input>
            </div>
            <div *ngSwitchCase="ReflexiveQuestionType.PICK_LIST">
                <jhi-reflexive-picklist-input [name]="rqpl"
                    [options]="reflexiveQuestion.picklistQuestionMeta.picklistItems"
                    (action)="answerReflexivePicklistQuestion(reflexiveQuestion)" [(value)]="reflexiveQuestion.triggeredAliases"
                    [triggeredAliases]="reflexiveQuestion.triggeredAliases"
                    [showNoneOfTheAbove]=reflexiveQuestion.picklistQuestionMeta.pickListNoneOfTheAboveVisible
                    [summaryMode]="summaryMode" [question]="reflexiveQuestion"
                    [searchEnabled]="reflexiveQuestion.picklistQuestionMeta.picklistSearchEnabled"
                    [searchText]="reflexiveQuestion.picklistQuestionMeta.picklistSearchText"
                    [category]="disclosure.category.code" [disclosureIdentifier]="disclosureIdentifier">
                </jhi-reflexive-picklist-input>
            </div>
        </div>
    </div>
